"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxGroup = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Text = require("../Text/Text");
var _CheckboxGroupModule = _interopRequireDefault(require("./CheckboxGroup.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const CheckboxGroup = /*#__PURE__*/React.forwardRef((_ref, forwardRef) => {
  let {
    align = 'vertical',
    disabled = false,
    name,
    value: checkedList,
    onChange,
    classNames,
    error = false,
    errorText = '',
    children
  } = _ref;
  const onChangeHandler = _ref2 => {
    let {
      value,
      checked
    } = _ref2;
    const checkedListTemp = checkedList ? [...checkedList] : [];
    if (checked && !checkedListTemp.includes(value)) {
      checkedListTemp.push(value);
    } else if (!checked && checkedListTemp.includes(value)) {
      for (let i = 0; i < checkedListTemp.length; i++) {
        if (checkedListTemp[i] === value) {
          checkedListTemp.splice(i, 1);
          break;
        }
      }
    }
    onChange && onChange(checkedListTemp);
  };
  const childrenWithProps = React.Children.map(children, child => {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      const {
        value,
        disabled: disabledChild,
        error: errorChild,
        onChange
      } = child.props;
      const childOnChange = function () {
        onChangeHandler(...arguments);
        onChange && onChange(...arguments);
      };
      return /*#__PURE__*/React.cloneElement(child, {
        name,
        checked: !!checkedList?.includes(value),
        onChange: childOnChange,
        align,
        error: errorChild || error,
        disabled: disabledChild || disabled
      });
    }
    return child;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_CheckboxGroupModule.default.checkboxGroupContainer, classNames?.wrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)({
      [_CheckboxGroupModule.default.vertical]: align === 'vertical',
      [_CheckboxGroupModule.default.horizontal]: align === 'horizontal-fixed',
      [_CheckboxGroupModule.default.horizontalFluid]: align === 'horizontal-fluid'
    }, classNames?.checkboxGroup),
    ref: forwardRef
  }, childrenWithProps), error && /*#__PURE__*/React.createElement(_Text.BodySmall, {
    className: (0, _classify.default)(classNames?.errorText),
    color: "danger"
  }, errorText));
});
exports.CheckboxGroup = CheckboxGroup;